import EnbItem01 from './EnbItem01/EnbItem01'
import EnbProduto02 from './EnbItem02/EnbProduto02'

export default {
  EnbItem01,
  EnbProduto02
}
